module.exports = __webpack_public_path__ + "img/Free Response 08.f30e7b18.png";